// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default (
    <svg
        width='142'
        height='87'
        viewBox='0 0 142 87'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clipPath='url(#clip0_4212_90995)'>
            <rect
                x='15'
                y='15'
                width='112'
                height='44'
                rx='3'
                fill='var(--button-bg)'
                fillOpacity='0.12'
            />
            <path
                d='M29.5 75L29.5 47L40 47'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M45 43H29.5V9.5L22.5 2.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 0 0 -1 20 5)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 0 0 -1 27 78)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <path
                d='M127 22.5L117 22.5L117 49'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='128.5'
                cy='22.5'
                r='2.5'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <path
                d='M54.605 67.5638L41 81V12C41 10.8954 41.8954 10 43 10H109C110.105 10 111 10.8954 111 12V64.9868C111 66.0914 110.105 66.9868 109 66.9868H56.0103C55.4842 66.9868 54.9793 67.1941 54.605 67.5638Z'
                fill='#28427B'
            />
            <path
                d='M49.605 62.5638L36 76V7C36 5.89543 36.8954 5 38 5H104C105.105 5 106 5.89543 106 7V59.9868C106 61.0914 105.105 61.9868 104 61.9868H51.0103C50.4842 61.9868 49.9793 62.1941 49.605 62.5638Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M49.2536 62.2081L36.5 74.8035V7C36.5 6.17157 37.1716 5.5 38 5.5H104C104.828 5.5 105.5 6.17157 105.5 7V59.9868C105.5 60.8153 104.828 61.4868 104 61.4868H51.0103C50.3527 61.4868 49.7215 61.746 49.2536 62.2081Z'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
            />
            <circle
                cx='54'
                cy='24'
                r='9'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M69 20H85'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M46 44H96'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M46 51H68'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M69 26H94'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M46 38H63'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M67 38H85'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                opacity='0.32'
                d='M114.218 87.29C106.772 87.1409 100.598 84.5917 95.6936 79.6423C90.7897 74.6929 88.2252 68.5281 88 61.1479C88.2213 53.7639 90.7859 47.5971 95.6936 42.6477C100.601 37.6983 106.776 35.1491 114.218 35C121.591 35.1529 127.73 37.7021 132.633 42.6477C137.537 47.5933 140.102 53.76 140.327 61.1479C140.098 68.5319 137.534 74.6967 132.633 79.6423C127.733 84.5879 121.595 87.1371 114.218 87.29Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M111.218 82.7899C103.897 82.6411 97.8524 80.1385 93.0488 75.2904C88.243 70.4399 85.7248 64.403 85.5002 57.1477C85.7211 49.8888 88.2392 43.8501 93.0487 38.9998C97.8561 34.1515 103.901 31.6489 111.218 31.5001C118.465 31.6526 124.474 34.1544 129.278 38.9998C134.084 43.8462 136.602 49.8848 136.827 57.1477C136.598 64.407 134.08 70.4439 129.278 75.2904C124.478 80.1356 118.469 82.6374 111.218 82.7899Z'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
            />
            <path
                d='M111.042 77C105.35 76.886 100.63 74.9359 96.8812 71.1498C93.1325 67.3636 91.1721 62.6478 91 57.0022C91.1692 51.3537 93.1296 46.6364 96.8812 42.8502C100.633 39.0641 105.353 37.114 111.042 37C116.678 37.1169 121.37 39.067 125.119 42.8502C128.867 46.6334 130.828 51.3508 131 57.0022C130.825 62.6507 128.865 67.3666 125.119 71.1498C121.373 74.933 116.681 76.8831 111.042 77Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M111.041 76.4999C105.475 76.3862 100.885 74.4827 97.2365 70.798C93.5858 67.1108 91.6718 62.5228 91.5002 57.0021C91.6689 51.4785 93.583 46.8892 97.2364 43.2022C100.888 39.5172 105.478 37.6138 111.041 37.5001C116.552 37.6167 121.114 39.5192 124.764 43.2022C128.414 46.8862 130.328 51.4754 130.5 57.0021C130.325 62.5259 128.411 67.1139 124.763 70.798C121.117 74.4807 116.555 76.3833 111.041 76.4999Z'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
            />
            <path
                d='M111 35.5V57L120.5 66.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinejoin='round'
            />
            <circle
                cx='111'
                cy='57'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.8'
            />
        </g>
        <defs>
            <clipPath id='clip0_4212_90995'>
                <rect
                    width='142'
                    height='87'
                    fill='white'
                />
            </clipPath>
        </defs>
    </svg>
);
